module.exports = __webpack_public_path__ + "img/minus.e66f3d13.svg";